// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

export default {
  name: 'private_elements',
  dialogs: [
    { name: 'privacy-dialog' },
    { name: 'about-dialog' }
  ],
  onEngineReady: function (app) {
    // Add all data sources.
    const doUrl = process.env.VUE_APP_SKYDATA_SERVER
    const core = app.$stel.core
    // Stars
    core.stars.addDataSource({ url: doUrl + 'swe-data-packs/minimal/2020-09-01/minimal_2020-09-01_186e7ee2/stars', key: 'minimal' })
    core.stars.addDataSource({ url: doUrl + 'swe-data-packs/base/2020-09-01/base_2020-09-01_1aa210df/stars', key: 'base' })
    core.stars.addDataSource({ url: doUrl + 'swe-data-packs/extended/2020-03-11/extended_2020-03-11_26aa5ab8/stars', key: 'extended' })
    core.stars.addDataSource({ url: doUrl + 'surveys/gaia/v1', key: 'gaia' })

    core.landscapes.addDataSource({ url: doUrl + 'landscapes/v1/guereins', key: 'guereins' })
    core.milkyway.addDataSource({ url: doUrl + 'surveys/milkyway/v1' })
    core.dss.addDataSource({ url: doUrl + 'surveys/dss/v1' })

    core.skycultures.addDataSource({ url: doUrl + 'skycultures/v3/western', key: 'western' })

    // DSOs
    core.dsos.addDataSource({ url: doUrl + 'swe-data-packs/base/2020-09-01/base_2020-09-01_1aa210df/dso' })
    core.dsos.addDataSource({ url: doUrl + 'swe-data-packs/extended/2020-03-11/extended_2020-03-11_26aa5ab8/dso' })

    core.minor_planets.addDataSource({ url: doUrl + 'mpc/v1/mpcorb.dat', key: 'mpc_asteroids' })
    core.comets.addDataSource({ url: doUrl + 'mpc/v1/CometEls.txt?v=2019-12-17', key: 'mpc_comets' })

    // Artificial satellites. Add v= to defeat locally cached files before
    // this date because they had incorrect Cache-Control: max-age of 1 year
    // set on the server (instead of 1 hour now).
    core.satellites.addDataSource({ url: doUrl + 'skysources/v1/tle_satellite.jsonl.gz?v=2019-09-16', key: 'jsonl/sat' })

    core.planets.addDataSource({ url: doUrl + 'surveys/sso/callisto/v1', key: 'callisto' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/default/v1', key: 'default' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/europa/v1', key: 'europa' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/ganymede/v1', key: 'ganymede' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/io/v1', key: 'io' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/jupiter/v1', key: 'jupiter' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/mars/v1', key: 'mars' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/mercury/v1', key: 'mercury' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/moon/v1', key: 'moon' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/moon-normal/v1', key: 'moon-normal' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/neptune/v1', key: 'neptune' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/saturn/v1', key: 'saturn' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/sun/v1', key: 'sun' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/uranus/v1', key: 'uranus' })
    core.planets.addDataSource({ url: doUrl + 'surveys/sso/venus/v1', key: 'venus' })

    // Set this variable to tru to skip adding default base data sources
    // as is done in the open source version
    app.dataSourceInitDone = true
  }
}
